import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "periodTypeInput",
    "trimesterFilter",
    "monthFilter",
    "form",
  ];

  selectPeriodType(event) {
    const btn = event.currentTarget;
    const periodType = btn.dataset.periodType;

    // Update hidden input
    this.periodTypeInputTarget.value = periodType;

    // Clear irrelevant filters when switching tabs
    const trimesterSelect = this.trimesterFilterTarget.querySelector("select");
    const monthSelect = this.monthFilterTarget.querySelector("select");

    if (periodType !== "trimester" && trimesterSelect) {
      trimesterSelect.value = "";
    }
    if (periodType !== "pedagogical_month" && monthSelect) {
      monthSelect.value = "";
    }

    // Update tab styles (GO4S DS segmented control)
    const tabs = this.element.querySelectorAll("[data-tab-btn]");
    tabs.forEach((tab) => {
      tab.className = "ds-segmented__btn";
      tab.setAttribute("aria-selected", "false");
    });
    btn.className = "ds-segmented__btn";
    btn.setAttribute("aria-selected", "true");

    // Show/hide dropdowns
    this.trimesterFilterTarget.classList.toggle(
      "hidden",
      periodType !== "trimester",
    );
    this.monthFilterTarget.classList.toggle(
      "hidden",
      periodType !== "pedagogical_month",
    );

    // Auto-submit for tabs without dropdown (all, academic_year)
    if (periodType === "" || periodType === "academic_year") {
      this.formTarget.submit();
    }
  }
}
